import { useState } from 'react';

const useForm = (callback, initialInputState = {}, validate, recaptchaRef) => {
    const [values, setValues] = useState(initialInputState);
    const [errors, setErrors] = useState(initialInputState);

    const handleInputChange = event => {
        const { name, value } = event.target
        setValues(
            {
                ...values,
                [name]: value
            }
        )
    };

    const onChange = () => {
        const getRecapValue = recaptchaRef.current.getValue();
 
        if (getRecapValue) {
            setValues(
                {
                    ...values,
                    reCaptchaChecked: true,
                }
            )
        }
    }

    const handleChecked = (event) => {
        if (event.target.name === 'termsConditionBox') {
            setValues(
                {
                    ...values,
                    termsConditionBox: !values.termsConditionBox,
                }
            )
        } else if (event.target.name === 'termsAcknowledgeBox') {
            setValues(
                {
                    ...values,
                    termsAcknowledgeBox: !values.termsAcknowledgeBox
                }
            )
        }
    }



    const handleSubmit = () => {
        if (Object.keys(validate(values)).length === 0) {
            callback()
            setValues(initialInputState)
            setErrors(initialInputState)
        } else {
            setErrors(validate(values))
        }
    };

    return {
        handleInputChange,
        onChange,
        handleSubmit,
        handleChecked,
        values,
        errors,
    };
};

export default useForm;